/* global $ */
import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';

export class RedirectToManagementConsoleConfirmation extends Component {

    componentDidMount() {
        var self = this;
        $('#saveAndRedirectConfirmation').modal({
            closable  : false,
            onApprove : function() {
                self.props.submitRegistration(1);
            }
        });
        $('#redirectErrorMessage').modal({
            onApprove : function() {
                self.props.showLogin();
            }
        });
    }

    render() {
        return (
            <div>
                <div id="saveAndRedirectConfirmation" className="ui tiny modal">
                    <div className="content">
                        <p>
                            {this.props.showMessage('message_10_01')} <span className="purple">'{this.props.showMessage('message_10_02')}'</span> {this.props.showMessage('message_10_03')} <span className="purple">'{this.props.showMessage('message_10_04')}'</span> {this.props.showMessage('message_10_05')}
                        </p>
                    </div>
                    <div className="actions">
                        <Button className="ui button cancel secondary" id="cancelButton">{this.props.showMessage('message_10_04')}</Button>
                        <Button className="ui button approve primary" id="saveButton">{this.props.showMessage('message_10_02')} ></Button>
                    </div>
                </div>
                <div id="redirectErrorMessage" className="ui mini modal">
                    <div className="content">
                        <p>
                            {this.props.showMessage('message_10_06')}
                        </p>
                    </div>
                    <div className="actions">
                        <Button className="ui button approve primary">{this.props.showMessage('message_10_07')}</Button>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/windows/RedirectToManagementConsoleConfirmation.jsx